@if (label) {
  <mat-label>{{ label | translate | async }}</mat-label>
}
<mat-form-field [appearance]="appearance" [style.fontSize.px]="fontSize">
  <textarea
    matInput
    [rows]="rows"
    [formControl]="control"
    [placeholder]="placeholder | translate | async"
    (change)="onInputChange(control.value)"
    (blur)="onTouched()"
    (input)="onTouched()"
  ></textarea>

  @if (control.touched && control.errors?.required) {
    <mat-error>
      @if (label) {
        {{ label + ' is required' | translate | async }}
      } @else {
        {{ 'This field is required' | translate | async }}
      }
    </mat-error>
  }
</mat-form-field>
